import { useEffect } from 'react'

/**
 * componentDidMountのhooksを返却する。
 * @param callback 実行する関数
 */
export const useDidMount = (callback: () => any): void => {
  useEffect(() => {
    if (typeof callback === 'function') {
      callback()
    }
  }, [])
}
